const Component = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.41578 7.00016H7C5.34315 7.00016 4 8.34331 4 10.0002V14.0002C4 15.657 5.34315 17.0002 7 17.0002H9L13.683 21.0978C14.9762 22.2293 17 21.3109 17 19.5926V15.5844L15 13.5844L15 19.5926L10.317 15.495C9.95243 15.176 9.48445 15.0002 9 15.0002H7C6.44772 15.0002 6 14.5524 6 14.0002V10.0002C6 9.44788 6.44772 9.00016 7 9.00016H9C9.38959 9.00016 9.76853 8.88645 10.0916 8.67599L8.41578 7.00016Z"
        fill="white"
      />
      <path
        d="M15 10.756L15 4.4077L11.6143 7.37022L10.1969 5.95287L13.683 2.90255C14.9762 1.77103 17 2.68938 17 4.4077V12.756L15 10.756Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.29289 2.29289C2.68342 1.90237 3.31658 1.90237 3.70711 2.29289L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L2.29289 3.70711C1.90237 3.31658 1.90237 2.68342 2.29289 2.29289Z"
        fill="white"
      />
    </svg>
  );
};

export default Component;
